import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'

export function LoadingScreen() {
  const { t } = useTranslation()

  return (
    <BaseView flex={1} bgColor="background.screen">
      <BaseView flex={1} justify="center" align="center" px={24}>
        <BaseView
          style={{
            width: '50px',
            height: '50px',
            border: '3px solid rgba(255, 255, 255, 0.1)',
            borderTop: '3px solid #00CF46',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        />
        <BaseView mt={24}>
          <BaseText fontSize={16} color="label.default" textAlign="center">
            {t('common:loadingPaymentPage')}
          </BaseText>
        </BaseView>
      </BaseView>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </BaseView>
  )
}
